import React, { Fragment, Component } from 'react';
import MainLayout from '../layouts/mainLayout';
import moment from 'moment';
import { 
    getPetBreeds, 
    calculateallplans,
    getPlans,
    updateLead,
    sendLeadEmail,
    checkLossRatio
} from '../api/pets-api';
import { notifications } from '../helpers/utilities';
import { CURRENCY } from '../constants';
import { 
    Spin, Row, Col, Image, Divider, Popconfirm, Button, Popover, Badge, 
    Card, Typography, Modal, Form, Input, Radio, DatePicker, Select, Tooltip,
    Steps, Alert
} from 'antd';
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Sidebar from '../components/common/sidebar';

const { Title } = Typography;
const { Option } = Select;
const { Step } = Steps;

// Plan benefits constants
const BenifitsMap = {
    "Vital": 20000,
    "Favorite": 35000,
    "Optimum": 70000
};

class GetQouteFlowSecond extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // UI state
            spinning: false,
            planDivSpinning: false,
            tip: '',
            dataLoaded: false,
            errorMessage: '',
            visible: false,
            spin: false,
            disableBtn: false,
            
            // Data state
            petTypeBreeds: [],
            filteredBreeds: [],
            selectedPetType: null,
            plans: [
                { id: 0, title: 'Vital', annualy: 'basic' },
                { id: 1, title: 'Favorite', annualy: 'standard' },
                { id: 2, title: 'Optimum', annualy: 'premium' }
            ],
            preQoute: {
                petsWithPlans: []
            },
            userAlreadyExists: false,
            
            // Pet modal state
            isEditing: false,
            editingPetIndex: -1,
            selectedPetForEdit: null,
            lastFormUpdate: null,
            editFormValues: {},
            email: '',
            leadId: null, // Added leadId to track the lead
            isRenewal: false, // Track if this is a renewal quote
        };
        
        this.pageRef = React.createRef();
        this.formRef = React.createRef();
    }

    async componentDidMount() {
        await this.loadPetTypesAndBreeds();
        await this.loadPlansFromAPI(); // Load plans from API before calculating
        this.fetchCalculationForAllPlans();
        this.setState({
            leadId: localStorage.getItem('lead')
        });
        let isRenewal = localStorage.getItem('isRenewal');
        if (isRenewal) {
            this.setState({ isRenewal: true });
        } else {
            this.setState({ isRenewal: false });
        }
        
        // Track page view with Google Ads
        this.trackPageView();
        
        // Fire conversion event when user lands on quotation page
        this.trackConversion();
    }

    // -------------------- Google Ads Tracking Methods --------------------

    trackPageView = () => {
        try {
            // Google Ads tracking
            if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
                window.gtag('config', 'AW-11487089889', {
                    page_title: 'Quote Customization',
                    page_location: window.location.href,
                });
                console.log('Google Ads page view tracked');
            }

            // Facebook Pixel tracking
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
                window.fbq('track', 'PageView');
                console.log('Facebook Pixel PageView tracked on quote page');
            }
        } catch (error) {
            console.error('Error tracking page view:', error);
        }
    }

    trackConversion = () => {
        try {
            if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
                // Fire the Google Ads conversion event
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-11487089889/IUvXCOmx7oAbEOGpvOUq'
                });
                
                console.log('Google Ads conversion event fired on quotation page');
            }
        } catch (error) {
            console.error('Error tracking conversion:', error);
        }
    }

    trackViewItem = (petsWithPlans) => {
        try {
            if (typeof window !== 'undefined' && typeof window.gtag === 'function' && petsWithPlans?.length > 0) {
                // Google Ads tracking - create items array for each pet and their plans
                const items = [];
                
                petsWithPlans.forEach((pet, petIndex) => {
                    this.state.plans.forEach((plan, planIndex) => {
                        items.push({
                            item_id: `${pet.name}_${plan.title}_${pet.petTypeId}_${pet.breedid}`,
                            item_name: `${plan.title} Plan for ${pet.name}`,
                            affiliation: 'Oslo Pet Insurance',
                            coupon: pet.discountApplied ? 'MULTI_PET_5' : '',
                            discount: pet.discountApplied ? (pet.plans[planIndex] * 0.05) : 0,
                            index: petIndex,
                            item_brand: 'Oslo',
                            item_category: 'Pet Insurance',
                            item_category2: pet.type === 'dog' ? 'Dog' : 'Cat',
                            item_category3: plan.title,
                            item_list_id: 'quote_plans',
                            item_list_name: 'Quote Plans',
                            price: pet.plans[planIndex],
                            quantity: 1
                        });
                    });
                });

                // Calculate total value
                const totalValue = petsWithPlans.reduce((total, pet) => {
                    return total + (pet.plans[pet.planId] || 0);
                }, 0);

                window.gtag('event', 'view_item', {
                    currency: 'AED',
                    value: totalValue,
                    items: items
                });

                console.log('Google Ads view_item event fired with data:', {
                    currency: 'AED',
                    value: totalValue,
                    items_count: items.length
                });
            }

            // Facebook Pixel tracking
            if (typeof window !== 'undefined' && typeof window.fbq === 'function' && petsWithPlans?.length > 0) {
                const totalValue = petsWithPlans.reduce((total, pet) => {
                    return total + (pet.plans[pet.planId] || 0);
                }, 0);

                // Track ViewContent event for Facebook Pixel
                window.fbq('track', 'ViewContent', {
                    content_type: 'product',
                    content_ids: petsWithPlans.map(pet => `${pet.name}_${this.state.plans[pet.planId].title}`),
                    content_name: 'Pet Insurance Quote',
                    content_category: 'Pet Insurance',
                    value: totalValue,
                    currency: 'AED'
                });

                console.log('Facebook Pixel ViewContent event fired with value:', totalValue);
            }
        } catch (error) {
            console.error('Error tracking view_item:', error);
        }
    }

    trackPlanChange = (pet, newPlanIndex, petIndex) => {
        try {
            if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
                const selectedPlan = this.state.plans[newPlanIndex];
                
                // Google Ads tracking
                window.gtag('event', 'select_item', {
                    currency: 'AED',
                    value: pet.plans[newPlanIndex],
                    items: [{
                        item_id: `${pet.name}_${selectedPlan.title}_${pet.petTypeId}_${pet.breedid}`,
                        item_name: `${selectedPlan.title} Plan for ${pet.name}`,
                        affiliation: 'Oslo Pet Insurance',
                        coupon: pet.discountApplied ? 'MULTI_PET_5' : '',
                        discount: pet.discountApplied ? (pet.plans[newPlanIndex] * 0.05) : 0,
                        index: petIndex,
                        item_brand: 'Oslo',
                        item_category: 'Pet Insurance',
                        item_category2: pet.type === 'dog' ? 'Dog' : 'Cat',
                        item_category3: selectedPlan.title,
                        item_list_id: 'quote_plans',
                        item_list_name: 'Quote Plans',
                        price: pet.plans[newPlanIndex],
                        quantity: 1
                    }]
                });

                console.log(`Google Ads select_item event fired for ${pet.name} - ${selectedPlan.title}`);
            }

            // Facebook Pixel tracking
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
                const selectedPlan = this.state.plans[newPlanIndex];
                
                // Track custom event for plan change
                window.fbq('trackCustom', 'PlanSelected', {
                    content_name: `${selectedPlan.title} Plan for ${pet.name}`,
                    content_category: 'Pet Insurance',
                    content_type: 'product',
                    value: pet.plans[newPlanIndex],
                    currency: 'AED',
                    pet_name: pet.name,
                    plan_type: selectedPlan.title
                });

                console.log(`Facebook Pixel PlanSelected event fired for ${pet.name} - ${selectedPlan.title}`);
            }
        } catch (error) {
            console.error('Error tracking plan change:', error);
        }
    }

    trackBeginCheckout = () => {
        try {
            if (typeof window !== 'undefined' && typeof window.gtag === 'function' && this.state.preQoute?.petsWithPlans?.length > 0) {
                const petsWithPlans = this.state.preQoute.petsWithPlans;
                
                // Google Ads tracking - create items array for selected plans
                const items = petsWithPlans.map((pet, petIndex) => ({
                    item_id: `${pet.name}_${this.state.plans[pet.planId].title}_${pet.petTypeId}_${pet.breedid}`,
                    item_name: `${this.state.plans[pet.planId].title} Plan for ${pet.name}`,
                    affiliation: 'Oslo Pet Insurance',
                    coupon: pet.discountApplied ? 'MULTI_PET_5' : '',
                    discount: pet.discountApplied ? (pet.plans[pet.planId] * 0.05) : 0,
                    index: petIndex,
                    item_brand: 'Oslo',
                    item_category: 'Pet Insurance',
                    item_category2: pet.type === 'dog' ? 'Dog' : 'Cat',
                    item_category3: this.state.plans[pet.planId].title,
                    item_list_id: 'selected_plans',
                    item_list_name: 'Selected Plans',
                    price: pet.plans[pet.planId],
                    quantity: 1
                }));

                // Calculate total value
                const totalValue = petsWithPlans.reduce((total, pet) => {
                    return total + (pet.plans[pet.planId] || 0);
                }, 0);

                window.gtag('event', 'begin_checkout', {
                    currency: 'AED',
                    value: totalValue,
                    items: items
                });

                console.log('Google Ads begin_checkout event fired with data:', {
                    currency: 'AED',
                    value: totalValue,
                    items_count: items.length
                });
            }

            // Facebook Pixel tracking
            if (typeof window !== 'undefined' && typeof window.fbq === 'function' && this.state.preQoute?.petsWithPlans?.length > 0) {
                const petsWithPlans = this.state.preQoute.petsWithPlans;
                
                const totalValue = petsWithPlans.reduce((total, pet) => {
                    return total + (pet.plans[pet.planId] || 0);
                }, 0);

                // Track InitiateCheckout event for Facebook Pixel
                window.fbq('track', 'InitiateCheckout', {
                    content_type: 'product',
                    content_ids: petsWithPlans.map(pet => `${pet.name}_${this.state.plans[pet.planId].title}`),
                    content_name: 'Pet Insurance Plans',
                    content_category: 'Pet Insurance',
                    value: totalValue,
                    currency: 'AED',
                    num_items: petsWithPlans.length
                });

                console.log('Facebook Pixel InitiateCheckout event fired with value:', totalValue);
            }
        } catch (error) {
            console.error('Error tracking begin_checkout:', error);
        }
    }

    // -------------------- API Methods --------------------

    loadPetTypesAndBreeds = async () => {
        try {
            const response = await getPetBreeds();
            
            if (response && response.status === 200) {
                const petTypeBreeds = response.data.result.map(type => ({
                    id: type.id,
                    name: type.name,
                    breeds: type.Breads.map(breed => ({
                        id: breed.id,
                        name: breed.name
                    }))
                }));
                
                this.setState({ 
                    petTypeBreeds, 
                    allBreeds: petTypeBreeds 
                });
            }
        } catch (error) {
            console.error("Error loading pet types and breeds:", error);
            notifications('error', 'Failed to load pet types and breeds');
        }
    }

    fetchCalculationForAllPlans = async () => {
        // Set appropriate loading state
        if (!this.state.dataLoaded) {
            this.setState({ spinning: true, tip: 'Loading your quote...' });
        } else {
            this.setState({ planDivSpinning: true });
        }
        
        try {
            // Get stored quote data
            const storedData = localStorage.getItem('osloQuoteData');
            
            
            if (!storedData) {
                this.setState({ 
                    spinning: false, 
                    planDivSpinning: false, 
                    errorMessage: 'No saved quote found. Please start a new quote.',
                    dataLoaded: false
                });
                return;
            }

            
            // Parse and validate stored data
            const quoteData = JSON.parse(storedData);
            
            // Check loss ratio for each pet and set default values accordingly
            if (quoteData?.pets?.length > 0) {
                const lossRatioChecks = await Promise.all(
                    quoteData.pets.map(async (pet) => {
                        try {
                            const response = await checkLossRatio({
                                email: quoteData.email,
                                petName: pet.name,
                                breedId: pet.breedId,
                                dob: pet.dob
                            });
                            
                            if (response && response.data && response.data.result) {
                                return response.data.result.lossRatioBreached || false;
                            }
                            return false;
                        } catch (error) {
                            console.error('Error checking loss ratio for pet:', pet.petName, error);
                            return false;
                        }
                    })
                );
                
                quoteData.pets = quoteData.pets.map((pet, index) => ({
                    ...pet,
                    reimbursement: lossRatioChecks[index] ? 70 : (pet.reimbursement || 80),
                    deductible: lossRatioChecks[index] ? 500 : (pet.deductible || 250)
                }));
                
                localStorage.setItem('osloQuoteData', JSON.stringify(quoteData));
            }

            this.setState({email: quoteData.email || ''});


            // Call API to calculate prices
            const response = await calculateallplans(quoteData);
            
            if (response && response.status === 200) {
                const result = response.data.result;
                
                // Map API response to state format
                const petsWithPlans = result.petQuotes.map((petQuote, index) => {
                    debugger;
                    const planPrices = petQuote.planOptions.map(plan => Math.round(plan.monthlyDiscountedPrice));
                    const quotePlanPrices = petQuote.planOptions.map(plan => Math.round(plan.usBasePrice));
                    //quoteData.pets[index].planId = petQuote.planOptions[1].planId;
                    

                    //get selected plan ID from the API response
                    let selectedPlanId = this.state.plans.find(plan => plan.apiId === quoteData.pets[index].planId)?.id;
                    if (selectedPlanId === undefined) {
                        selectedPlanId = 1; // Default to Favorite if not found

                    }
                    quoteData.pets[index].planId = this.state.plans[selectedPlanId].apiId;
                    quoteData.pets[index].discountApplied = petQuote.discountApplied;
                    localStorage.setItem('osloQuoteData', JSON.stringify(quoteData));

                    // Update quoteObj with new plan prices
                    this.updateQuoteObj(index, { plans: quotePlanPrices, discountApplied: petQuote.discountApplied });


                    return {
                        id: petQuote.petName,
                        name: petQuote.petName,
                        type: this.getPetTypeNameById(petQuote.petTypeId).toLowerCase(),
                        petTypeId: petQuote.petTypeId,
                        breed: petQuote.breedId,
                        breedid: petQuote.breedId,
                        dob: petQuote.dob,
                        gender: petQuote.gender,
                        planId: selectedPlanId, // default to favorite (middle option)
                        reimburseId: petQuote.looseRatioBreached ? 0 : this.getReimburseIdFromValue(petQuote.planOptions[1].reimbursement),
                        deductionId: petQuote.looseRatioBreached ? 2 : this.getDeductibleIdFromValue(petQuote.planOptions[1].deductible),
                        plans: planPrices,
                        apioptions: petQuote.planOptions,
                        dbPlanId: quoteData.pets[index].planId,
                        existingPet: petQuote.existingPet || false,
                        isPrimaryPet: petQuote.isPrimary || false, 
                        discountApplied: petQuote.discountApplied || false,
                        discount: petQuote.discount || 0,
                        looseRatioBreached: petQuote.looseRatioBreached || false,
                        currentPlan: petQuote.currentPlan || null,
                        currentPlanId: petQuote.currentPlanId || null
                    };
                });
                this.setState({
                    preQoute: { petsWithPlans },
                    userAlreadyExists: result.userExists,
                    dataLoaded: true,
                    spinning: false,
                    planDivSpinning: false,
                    errorMessage: ''
                }, () => {
                    // Fire Google Ads view_item event after state is updated
                    this.trackViewItem(petsWithPlans);
                });
            } else {
                this.handleApiError('Failed to load quote data. Please try again.');
            }
        } catch (error) {
            console.error('Error loading quote data:', error);
            this.handleApiError('Error loading quote data. Please try again.');
        }
    };

    loadPlansFromAPI = async () => {
        try {
            const response = await getPlans();
            
            if (response && response.status === 200) {
                const apiPlans = response.data.result;
                
                // Map API plans to state plans with correct format
                const updatedPlans = [
                    { 
                        id: 0, 
                        title: 'Vital', 
                        annualy: 'basic',
                        apiId: apiPlans.find(p => p.title === 'Vital')?.id 
                    },
                    { 
                        id: 1, 
                        title: 'Favorite', 
                        annualy: 'standard',
                        apiId: apiPlans.find(p => p.title === 'Favorite')?.id 
                    },
                    { 
                        id: 2, 
                        title: 'Optimum', 
                        annualy: 'premium',
                        apiId: apiPlans.find(p => p.title === 'Optimum')?.id 
                    }
                ];
                
                this.setState({ plans: updatedPlans });
            }
        } catch (error) {
            console.error("Error loading plans:", error);
            notifications('error', 'Failed to load plan data');
        }
    }

    // -------------------- Helper Methods --------------------
    
    handleApiError = (message) => {
        this.setState({
            spinning: false,
            planDivSpinning: false,
            errorMessage: message,
            dataLoaded: false
        });
    }

    getPetTypeNameById = (id) => {
        const { petTypeBreeds } = this.state;
        const petType = petTypeBreeds.find(type => type.id === id);
        return petType ? petType.name : 'Unknown';
    };

    getReimburseIdFromValue = (value) => {
        if (value === 70) return 0;
        if (value === 80) return 1;
        if (value === 90) return 2;
        return 1; // Default to 80%
    };
    
    getDeductibleIdFromValue = (value) => {
        if (value === 100) return 0;
        if (value === 250) return 1;
        if (value === 500) return 2;
        return 1; // Default to 250
    };

    getReimburseValue = (reimburseId) => {
        const values = [70, 80, 90];
        return values[reimburseId] || 80;
    }

    getDeductibleValue = (deductionId) => {
        const values = [100, 250, 500];
        return values[deductionId] || 250;
    }

    // -------------------- Plan Selection Methods --------------------
    
    changePlan = (index, objIndex, planId) => {
        const preQoute = {...this.state.preQoute};
        const pet = preQoute.petsWithPlans[objIndex];
        
        // Track the plan change before updating state
        this.trackPlanChange(pet, index, objIndex);
        
        preQoute.petsWithPlans[objIndex].planId = index;
        
        this.setState({ 
            preQoute, 
            planDivSpinning: true 
        });
        
        let quoteData = localStorage.getItem('osloQuoteData');
    
        if (quoteData) {
            quoteData = JSON.parse(quoteData);
            // Use the API ID of the new plan instead of the current one
            quoteData.pets[objIndex].planId = this.state.plans[index].apiId;
            localStorage.setItem('osloQuoteData', JSON.stringify(quoteData));
            
            // Update quoteObj with index-based planId
            this.updateQuoteObj(objIndex, { planId: index });
        }

        // Simulate API call with delay
        setTimeout(() => {
            this.setState({ planDivSpinning: false });
        }, 500);
    }

    changeReimburse = (index, objIndex) => {
        let quoteData = localStorage.getItem('osloQuoteData');
        
        if (quoteData) {
            quoteData = JSON.parse(quoteData);
            quoteData.pets[objIndex].reimbursement = index === 0 ? 70 : index === 1 ? 80 : 90;
            localStorage.setItem('osloQuoteData', JSON.stringify(quoteData));
            
            // Update quoteObj with index-based reimburseId
            this.updateQuoteObj(objIndex, { reimburseId: index });
        }
        
        this.fetchCalculationForAllPlans();
    }

    changeDeduction = (index, objIndex) => {
        let quoteData = localStorage.getItem('osloQuoteData');
        
        if (quoteData) {
            quoteData = JSON.parse(quoteData);
            quoteData.pets[objIndex].deductible = index === 0 ? 100 : index === 1 ? 250 : 500;
            localStorage.setItem('osloQuoteData', JSON.stringify(quoteData));
            
            // Update quoteObj with index-based deductionId
            this.updateQuoteObj(objIndex, { deductionId: index });
        }
        
        this.fetchCalculationForAllPlans();
    }

    // -------------------- Pet Modal Methods --------------------
    
    showModal = () => {
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
        
        this.setState({ 
            visible: true, 
            isEditing: false, 
            editingPetIndex: -1,
            filteredBreeds: [],
            selectedPetType: null
        });
    }

    handleCancel = () => {
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
        
        this.setState({ 
            visible: false,
            isEditing: false,
            editingPetIndex: -1,
            selectedPetForEdit: null,
            filteredBreeds: [],
            selectedPetType: null,
            lastFormUpdate: null
        });
    }

    changeType = (e) => {
        const value = e.target ? e.target.value : e;
        console.log('changeType called with value:', value); // Debug log
        
        const selectedType = this.state.petTypeBreeds.find(type => type.id === value);
        console.log('Found selectedType:', selectedType); // Debug log
        
        let filteredBreeds = [];
        
        if (selectedType?.breeds) {
            filteredBreeds = selectedType.breeds;
        }
        
        console.log('Filtered breeds:', filteredBreeds); // Debug log
        
        this.setState({ 
            selectedPetType: value, 
            filteredBreeds 
        }, () => {
            console.log('State updated - selectedPetType:', this.state.selectedPetType); // Debug log
            console.log('State updated - filteredBreeds:', this.state.filteredBreeds); // Debug log
        });
        
        if (this.formRef.current) {
            // Clear all validation errors for type field
            this.formRef.current.setFields([
                { name: 'type', errors: [] }
            ]);
            
            // Only clear breed and age when not in editing mode or when user manually changes type
            if (!this.state.isEditing || e.target) {
                this.formRef.current.setFieldsValue({ 
                    breed: undefined,
                    age: undefined
                });
                
                // Clear all validation errors for age and breed fields
                this.formRef.current.setFields([
                    { name: 'age', errors: [] },
                    { name: 'breed', errors: [] }
                ]);
            }
        }
    }

    editPet = async (index) => {
        // Get data from both localStorage sources to find the correct pet data
        const localStorageData = localStorage.getItem('osloQuoteData');
        const currentPetData = this.state.preQoute.petsWithPlans[index];
        
        console.log('Current pet data from state:', currentPetData); // Debug log
        
        let petToEdit = null;
        
        // Try to get pet data from localStorage first
        if (localStorageData) {
            const parsedData = JSON.parse(localStorageData);
            petToEdit = parsedData.pets[index];
            console.log('Pet data from localStorage:', petToEdit); // Debug log
        }
        
        // If no data from localStorage or incomplete, use state data
        if (!petToEdit || !petToEdit.petTypeId) {
            console.log('Using state data as fallback');
            petToEdit = {
                name: currentPetData.name,
                petTypeId: currentPetData.type === 'dog' ? 
                    this.state.petTypeBreeds.find(type => type.name.toLowerCase() === 'dog')?.id :
                    this.state.petTypeBreeds.find(type => type.name.toLowerCase() === 'cat')?.id,
                breedId: currentPetData.breedid || currentPetData.breed,
                dob: currentPetData.dob,
                gender: currentPetData.gender
            };
        }
        
        console.log('Final pet data to edit:', petToEdit); // Debug log
        
        if (petToEdit) {
            // Determine pet type - handle both string and number petTypeId
            let petTypeId;
            if (typeof petToEdit.petTypeId === 'string') {
                const petType = petToEdit.petTypeId.toLowerCase().includes('dog') ? 'Dog' : 'Cat';
                petTypeId = this.state.petTypeBreeds.find(type => type.name.toLowerCase() === petType.toLowerCase())?.id;
            } else {
                // If petTypeId is already a number, use it directly
                petTypeId = petToEdit.petTypeId;
            }
            
            console.log('Determined petTypeId:', petTypeId); // Debug log
            
            // Parse DOB more carefully
            let dobMoment = null;
            if (petToEdit.dob) {
                // Try different date formats
                dobMoment = moment(petToEdit.dob, ['YYYY-MM-DD', 'MM/YYYY', 'YYYY-MM', moment.ISO_8601], true);
                if (!dobMoment.isValid()) {
                    dobMoment = moment(petToEdit.dob);
                }
            }
            

            this.setState({isEditing: true});

            // Set state first with pet type to enable breed filtering
            await new Promise(resolve => {
                this.setState({
                    visible: true,
                    isEditing: true,
                    editingPetIndex: index,
                    selectedPetForEdit: petToEdit,
                    selectedPetType: petTypeId,
                    filteredBreeds: this.state.petTypeBreeds.find(type => type.id === petTypeId)?.breeds || [],
                }, resolve);
            });

            // Wait for modal to be visible and form to be ready
            setTimeout(() => {
                if (this.formRef.current) {
                    const formValues = {
                        name: petToEdit.name,
                        type: petTypeId,
                        gender: petToEdit.gender || 'Male',
                        age: dobMoment && dobMoment.isValid() ? dobMoment : null,
                        breed: petToEdit.breedId
                    };
                    
                    console.log('Setting form values:', formValues); // Debug log
                    
                    // Set form values directly
                    this.formRef.current.setFieldsValue(formValues);
                    
                    // Verify the values were set
                    setTimeout(() => {
                        const currentValues = this.formRef.current.getFieldsValue();
                        console.log('Form values after setting:', currentValues);
                    }, 100);
                }
            }, 100);
        }
    }

    // Add this helper method to update quoteObj
    updateQuoteObj = (petIndex, updates) => {
        let quoteObj = localStorage.getItem('quoteObj');
        
        if (quoteObj) {
            quoteObj = JSON.parse(quoteObj);
            
            if (quoteObj.petsWithPlans && quoteObj.petsWithPlans[petIndex]) {
                // Update the specific pet with the provided updates
                quoteObj.petsWithPlans[petIndex] = {
                    ...quoteObj.petsWithPlans[petIndex],
                    ...updates
                };
                
                localStorage.setItem('quoteObj', JSON.stringify(quoteObj));
            }
        }
    }

    addPetForm = async (values) => {
        // Don't call validateFields here since the form will already validate on submit
        debugger;
        try {
            const birthDate = moment(values.age);
            const now = moment();
            const ageInWeeks = now.diff(birthDate, 'weeks', true);

            // Check if pet is less than 8 weeks old
            if (ageInWeeks < 8) {
                // Calculate effective date: 15th of birth month + 8 weeks
                const fifteenthOfBirthMonth = moment(birthDate).date(15);
                const effectiveDate = fifteenthOfBirthMonth.add(2, 'M');
                
                // Show notification with effective date
                notifications(
                    `Please note: Since your pet is less than 8 weeks old, the policy effective date will be ${effectiveDate.format('MMMM DD, YYYY')} (8 weeks after the 15th of the birth month).`,
                    'Alert',
                    'warning'
                );
            }

            const newPet = {
                name: values.name,
                petTypeId: values.type,
                breedId: values.breed,
                dob: moment(values.age).format('YYYY-MM-DD'),
                gender: values.gender
            };

            let localStorageData = localStorage.getItem('osloQuoteData');
            
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                
                if (this.state.isEditing) {
                    localStorageData.pets[this.state.editingPetIndex] = newPet;
                    
                    // Update existing pet in quoteObj
                    this.updateQuoteObj(this.state.editingPetIndex, {
                        name: values.name,
                        gender: values.gender,
                        age: moment(values.age).toISOString(),
                        breed: values.breed,
                        type: values.type
                    });
                } else {
                    localStorageData.pets.push(newPet);
                    
                    // Add new pet to quoteObj
                    let quoteObj = localStorage.getItem('quoteObj');
                    if (quoteObj) {
                        quoteObj = JSON.parse(quoteObj);
                        
                        const newQuotePet = {
                            name: values.name,
                            gender: values.gender,
                            age: moment(values.age).toISOString(),
                            breed: values.breed,
                            type: values.type,
                            isPrimaryPet: quoteObj == null ? true : quoteObj?.petsWithPlans?.length === 0, // First pet is primary
                            planId: 1, // Default to Favorite (index 1)
                            reimburseId: 1, // Default to 80% (index 1)
                            deductionId: 1, // Default to 250 (index 1)
                            plans: [0, 0, 0] // Will be updated after API call
                        };
                        
                        quoteObj.petsWithPlans.push(newQuotePet);
                        localStorage.setItem('quoteObj', JSON.stringify(quoteObj));
                    }
                }
                
                localStorage.setItem('osloQuoteData', JSON.stringify(localStorageData));
            }

            this.fetchCalculationForAllPlans();
            
            // Reset form and state
            if (this.formRef.current) {
                this.formRef.current.resetFields();
            }
            
            notifications('success', this.state.isEditing 
                ? `${values.name} updated successfully!`
                : `${values.name} added to your quote!`);
            
            this.setState({
                visible: false,
                isEditing: false,
                editingPetIndex: -1,
                selectedPetForEdit: null,
                filteredBreeds: [],
                selectedPetType: null,
                lastFormUpdate: null
            });
        } catch (error) {
            console.log('Form submission error:', error);
            // Form validation errors will be shown automatically by Ant Design
        }
    }

    onPetFormFailed = (errorInfo) => {
        console.log('Form validation failed:', errorInfo);
        
        // Focus on the first field with error
        if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
            const firstErrorField = errorInfo.errorFields[0].name[0];
            if (this.formRef.current) {
                this.formRef.current.scrollToField(firstErrorField);
            }
        }
    }

    // -------------------- Validation Methods --------------------

    validatePetAge = (rule, value) => {
        
        return new Promise((resolve, reject) => {
            // If no value, reject with required message
            if (!value || !moment.isMoment(value)) {
                reject(new Error('Please select pet\'s date of birth!'));
                return;
            }

            // If no pet type selected, show error
            if (!this.state.selectedPetType) {
                reject(new Error('Please select pet type first'));
                return;
            }

            try {
                const birthDate = moment(value);
                const now = moment();
                
                // Validate that the date is a valid moment object
                if (!birthDate.isValid()) {
                    reject(new Error('Please select a valid date'));
                    return;
                }
                
                // Validate that the date is not in the future
                if (birthDate.isAfter(now)) {
                    reject(new Error('Birth date cannot be in the future'));
                    return;
                }

                const ageInWeeks = now.diff(birthDate, 'weeks', true);
                const ageInYears = now.diff(birthDate, 'years', true);

                // Find the pet type name
                const selectedType = this.state.petTypeBreeds.find(type => type.id === this.state.selectedPetType);
                const petTypeName = selectedType?.name?.toLowerCase();

                // Age restrictions based on pet type - allow pets less than 8 weeks
                if (petTypeName === 'dog' && ageInYears > 8) {
                    reject(new Error('Dogs cannot be older than 8 years'));
                    return;
                }

                if (petTypeName === 'cat' && ageInYears > 10) {
                    reject(new Error('Cats cannot be older than 10 years'));
                    return;
                }

                // If we reach here, validation passed
                resolve();
            } catch (error) {
                reject(new Error('Please select a valid date'));
            }
        });
    }

    validateGender = (rule, value) => {
        return new Promise((resolve, reject) => {
            if (!value) {
                reject(new Error('Please select gender!'));
                return;
            }
            resolve();
        });
    }

    ageChange = (date, dateString) => {
        // Clear validation errors when user makes a selection
        if (this.formRef.current && date) {
            // Clear the error immediately when a valid date is selected
            this.formRef.current.setFields([
                { name: 'age', errors: [] }
            ]);
        }
    }

    // -------------------- UI Component Methods --------------------
    
    removePet = (petIndex) => {
        let localStorageData = localStorage.getItem('osloQuoteData');
        
        if (localStorageData) {
            localStorageData = JSON.parse(localStorageData);
            
            // Don't remove if it's the last pet
            if (localStorageData.pets.length <= 1) {
                notifications('info', 'At least one pet is required');
                return;
            }
            
            localStorageData.pets = localStorageData.pets.filter((_, index) => index !== petIndex);
            localStorage.setItem('osloQuoteData', JSON.stringify(localStorageData));
            
            // Remove pet from quoteObj
            let quoteObj = localStorage.getItem('quoteObj');
            if (quoteObj) {
                quoteObj = JSON.parse(quoteObj);
                quoteObj.petsWithPlans = quoteObj.petsWithPlans.filter((_, index) => index !== petIndex);
                
                // Ensure at least one pet remains as primary
                if (quoteObj.petsWithPlans.length > 0 && !quoteObj.petsWithPlans.some(pet => pet.isPrimaryPet)) {
                    quoteObj.petsWithPlans[0].isPrimaryPet = true;
                }
                
                localStorage.setItem('quoteObj', JSON.stringify(quoteObj));
            }
            
            this.fetchCalculationForAllPlans();
        }
    }

    generateHeader = (pet, objIndex) => {

        return (
            <Row gutter={15} align="middle">
                <Col xs={24} sm={14} md={14} lg={14} xl={17}>
                    <div className="pet-name">
                        <Image 
                            preview={false}
                            className="img-fluid"
                            width={40}
                            src={pet.type === 'dog' ? '/images/icon-dog-sm.png' : '/images/icon-cat-sm.png'} 
                        />
                        <span className="name-text">{pet.name}</span>
                        
                        {/* Edit button */}
                        <Button
                            type="text"
                            style={{ padding: '0 5px' }}
                            onClick={() => this.editPet(objIndex)}
                        >
                            <Image 
                                preview={false}
                                className="img-fluid"
                                width={20}
                                src="/images/icon-pencil.png" 
                            />
                        </Button>

                        {/* Delete button - only visible when there's more than one pet */}
                        {this.state.preQoute.petsWithPlans.length > 1 && (
                            <>
                                <Divider type="vertical" />
                                <Popconfirm
                                    title="Are you sure you want to remove this pet?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => this.removePet(objIndex)}
                                >
                                    <Button
                                        style={{ verticalAlign: 'baseline' }}
                                        type="text"
                                        icon={<DeleteOutlined />}
                                    />
                                </Popconfirm>
                            </>
                        )}


                    </div>
                </Col>
                <Col xs={24} sm={10} md={10} lg={10} xl={7}>
                    <div className="recomended-plan full-width">
                        <div className="text-muted text-line">Recommended plan</div>
                        <div className="plan-price position-relative">
                            <Button className="btn-category btn-blue rounded-100">
                                {this.state.plans[1].title}
                            </Button>
                            <Fragment>
                                <sub>{CURRENCY || 'AED'}</sub>
                                <span className="price-amount">
                                    {Math.ceil(pet.plans[1])}
                                </span>
                            </Fragment>
                            <div className="payment-period">Monthly</div>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    saveQuote = async () => {
        this.setState({ spinning: true, tip: 'Saving your quote...' });

        const leadId = this.state.leadId;

        let obj = {
                    id:leadId,
                    email:this.state.email,
                    planObj:this.state.preQoute,
                    userObj:null
        }
        let res = await updateLead(obj);
        if (res.data.errors) {
            res.data.errors.map(error => {
                notifications('Error', error.msg, 'error');

            })
            this.setState({ spinning: false, tip: '' });
        } else {
            //notifications('Success', 'Your information saved in the system. You may receive an email with link to your quote', 'success');

            let usrObj = {
                user:{
                    email:obj.email,
                    leadId:res.data.result.id
                }
            }
    
            let resEmail = await sendLeadEmail(usrObj);
            if (resEmail.data.errors) {
                resEmail.data.errors.map(error => {
                    notifications('Error', error.msg, 'error');
                })
                this.setState({ spinning: false, tip: '' });
            } else {
                notifications('Success', 'Please check your inbox for email link for saved quotation.', 'success');
                this.setState({ spinning: false, tip: '' });
            }
        }
    }

    continuePurchase = () => {
        // Track begin_checkout event before proceeding
        this.trackBeginCheckout();
        
        this.setState({ spinning: true, tip: 'Processing your request...' });
        
        // Navigate to the user information page
        setTimeout(() => {
            this.setState({ spinning: false });
            this.props.history.push('/user-information');
        }, 500);
    }

    // -------------------- Helper method to safely set form values with retry logic --------------------
    
    setFormValuesWithRetry = (values, maxRetries = 5, delay = 150) => {
        const attemptSetValues = (attempt) => {
            if (this.formRef.current && attempt <= maxRetries) {
                try {
                    console.log(`Attempt ${attempt} to set form values:`, values);
                    
                    // Check if form fields are ready
                    const fieldsError = this.formRef.current.getFieldsError();
                    console.log('Form fields error state:', fieldsError);
                    
                    this.formRef.current.setFieldsValue(values);
                    
                    // Force the form to re-render
                    this.formRef.current.validateFields().catch(() => {
                        // Ignore validation errors, just trigger re-render
                    });
                    
                    // Verify that values were actually set
                    const currentValues = this.formRef.current.getFieldsValue();
                    console.log('Current form values after setting:', currentValues);
                    
                    // Check specifically for type field
                    const typeFieldValue = this.formRef.current.getFieldValue('type');
                    console.log('Type field value specifically:', typeFieldValue);
                    
                    // If type is still not set, retry
                    if (!currentValues.type && values.type && attempt < maxRetries) {
                        console.log('Type not set, retrying...');
                        setTimeout(() => attemptSetValues(attempt + 1), delay);
                    } else {
                        // Force component re-render to ensure UI updates
                        this.setState({ 
                            // Use a timestamp to force re-render
                            lastFormUpdate: Date.now() 
                        }, () => {
                            console.log('Component state updated to trigger re-render');
                            
                            // Final verification
                            setTimeout(() => {
                                const finalValues = this.formRef.current?.getFieldsValue();
                                console.log('Final form values after re-render:', finalValues);
                            }, 100);
                        });
                    }
                } catch (error) {
                    console.error('Error setting form values:', error);
                    if (attempt < maxRetries) {
                        setTimeout(() => attemptSetValues(attempt + 1), delay);
                    }
                }
            }
        };
        
        attemptSetValues(1);
    }

    // -------------------- Render Method --------------------
    
    render() {
        const { errorMessage, dataLoaded, filteredBreeds } = this.state;
        
        return (
            <Fragment>
                <MainLayout>
                <Spin spinning={this.state.spinning} tip={this.state.tip}>
                    
                        <Fragment>
                            <div className="container">
                                <Row gutter={[15, 15]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className="get-quote-wrp step-wizard-wrp full-width mt-5 mb-5">
                                            {/* Steps Indicator */}
                                            <Row gutter={15} justify="center" className="mb-5">
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Steps className="custom-wizard-steps mt-5" size="large" current={0}>
                                                        <Step key={1} title={'QUOTE'} />
                                                        <Step key={2} title={'YOUR INFO'} />
                                                        <Step key={3} title={'WELCOME'} />
                                                    </Steps>
                                                </Col>
                                            </Row>
                                            
                                            {/* Error Message */}
                                            {errorMessage && (
                                                <Row gutter={15} justify="center">
                                                    <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                        <Alert
                                                            message="Quote Error"
                                                            description={errorMessage}
                                                            type="error"
                                                            showIcon
                                                            action={
                                                                <Button type="primary" size="small" onClick={() => window.location.href = '/get-quote'}>
                                                                    Start a New Quote
                                                                </Button>
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            
                                            {/* Pet Cards */}
                                            {dataLoaded && (
                                                <Row gutter={15} justify="center">
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <div className="full-width mb-4" ref={this.pageRef}>
                                                            {this.state.preQoute.petsWithPlans.map((pet, objIndex) => (
                                                                <Fragment key={`pet-${objIndex}`}>
                                                                    <Title level={2} className="text-green section-title text-center mt-5 mb-4">
                                                                        Let's customize {pet.name}'s plan
                                                                    </Title>
                                                                    <Card 
                                                                        className="card-customize-plan" 
                                                                        title={this.generateHeader(pet, objIndex)}
                                                                    >
                                                                        {/* Plan Options */}
                                                                        <Spin spinning={this.state.planDivSpinning} size="medium">
                                                                            <Row gutter={[15, 15]} align="middle" justify="center">
                                                                                {this.state.plans.map((obj, index) => {
                                                                                    if(pet.looseRatioBreached)
                                                                                    {
                                                                                        const lastIndex = pet.currentPlan === 'Vital' ? 0 : pet.currentPlan === 'Favorite' ? 1 : 2;
                                                                                        if(index <= lastIndex){
                                                                                            return (
                                                                                            <Col 
                                                                                                key={index} 
                                                                                                className="pointer" 
                                                                                                xs={24} sm={24} md={8} lg={8} xl={8} 
                                                                                                onClick={() => this.changePlan(index, objIndex, pet.dbPlanId)}
                                                                                            >
                                                                                                <Card className={index === pet.planId ? 'selected plan-box' : 'plan-box'}>
                                                                                                    {pet.apioptions && pet.apioptions[index] && pet.apioptions[index].discount > 0 && (
                                                                                                        <div className='full-width px-2' align="right" >
                                                                                                            <Badge 
                                                                                                                count={`${pet.apioptions[index].discount * 100}% OFF`}
                                                                                                                style={{
                                                                                                                    backgroundColor: '#db3327ff',
                                                                                                                    fontSize: '12px',
                                                                                                                    fontWeight: 'bold',
                                                                                                                    zIndex: 1
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                        
                                                                                                    )}
                                                                                                    <Button className="btn-category btn-blue rounded-100">
                                                                                                        {obj.title}
                                                                                                    </Button>
                                                                                                    <div 
                                                                                                        className="plan-tagline mt-4" 
                                                                                                        style={{ 
                                                                                                            fontSize: '18px',
                                                                                                            wordWrap: 'break-word',
                                                                                                            overflowWrap: 'break-word',
                                                                                                            whiteSpace: 'normal',
                                                                                                            lineHeight: '1.4'
                                                                                                        }}
                                                                                                    >
                                                                                                        <div style={{ marginBottom: '4px' }}>
                                                                                                            AED {(BenifitsMap[obj.title].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))} Annual Benefits
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="plan-price text-center mt-4">
                                                                                                        <sub>{CURRENCY || 'AED'}</sub>
                                                                                                        &nbsp;
                                                                                                        <span className="price-amount">
                                                                                                            {pet.plans[index]}
                                                                                                        </span>
                                                                                                        <div className="full-width">Monthly</div>
                                                                                                    </div>
                                                                                                    <div className="get-quote full-width mt-3">
                                                                                                        <figure><i className="fa fa-check"></i></figure>
                                                                                                    </div>
                                                                                                </Card>
                                                                                            </Col>);
                                                                                        }
                                                                                        
                                                                                    }else{
                                                                                        return (
                                                                                        <Col 
                                                                                            key={index} 
                                                                                            className="pointer" 
                                                                                            xs={24} sm={24} md={8} lg={8} xl={8} 
                                                                                            onClick={() => this.changePlan(index, objIndex, pet.dbPlanId)}
                                                                                        >
                                                                                            <Card className={index === pet.planId ? 'selected plan-box' : 'plan-box'}>
                                                                                                {pet.apioptions && pet.apioptions[index] && pet.apioptions[index].discount > 0 && (
                                                                                                    <div className='full-width px-2' align="right" >
                                                                                                        <Badge 
                                                                                                            count={`${pet.apioptions[index].discount * 100}% OFF`}
                                                                                                            style={{
                                                                                                                backgroundColor: '#db3327ff',
                                                                                                                fontSize: '12px',
                                                                                                                fontWeight: 'bold',
                                                                                                                zIndex: 1
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                    
                                                                                                )}
                                                                                                <Button className="btn-category btn-blue rounded-100">
                                                                                                    {obj.title}
                                                                                                </Button>
                                                                                                <div 
                                                                                                    className="plan-tagline mt-4" 
                                                                                                    style={{ 
                                                                                                        fontSize: '18px',
                                                                                                        wordWrap: 'break-word',
                                                                                                        overflowWrap: 'break-word',
                                                                                                        whiteSpace: 'normal',
                                                                                                        lineHeight: '1.4'
                                                                                                    }}
                                                                                                >
                                                                                                    <div style={{ marginBottom: '4px' }}>
                                                                                                        AED {(BenifitsMap[obj.title].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))} Annual Benefits
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="plan-price text-center mt-4">
                                                                                                    <sub>{CURRENCY || 'AED'}</sub>
                                                                                                    &nbsp;
                                                                                                    <span className="price-amount">
                                                                                                        {pet.plans[index]}
                                                                                                    </span>
                                                                                                    <div className="full-width">Monthly</div>
                                                                                                </div>
                                                                                                <div className="get-quote full-width mt-3">
                                                                                                    <figure><i className="fa fa-check"></i></figure>
                                                                                                </div>
                                                                                            </Card>
                                                                                        </Col>);
                                                                                    }

                                                                                    
                                                                                })}
                                                                            </Row>
                                                                        </Spin>
                                                                        
                                                                        {/* Reimbursement & Deductible Options */}
                                                                        <Row gutter={[15, 15]} align="middle" className="mb-5">
                                                                            <Col xs={24} sm={11} md={11} lg={11} xl={11} className="text-center mt-4">
                                                                                <Title level={5} className="text-muted mb-4">REIMBURSEMENT</Title>
                                                                                <div className="steper">
                                                                                    {[
                                                                                        { reimbursment: 70 },
                                                                                        { reimbursment: 80 },
                                                                                        { reimbursment: 90 }
                                                                                    ].map((obj, index) => {
                                                                                        if(pet.looseRatioBreached)
                                                                                        {
                                                                                            if(index === 0){
                                                                                                return (
                                                                                                    <div 
                                                                                                    key={index} 
                                                                                                    className="pointer step-inner" 
                                                                                                    onClick={() => this.changeReimburse(index, objIndex)}
                                                                                                    >
                                                                                                        <div className={index === pet.reimburseId ? 'step-dot step-slected' : 'step-dot'}></div>
                                                                                                        <strong>{obj.reimbursment}%</strong>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            return null;
                                                                                        }
                                                                                        else{
                                                                                            return (
                                                                                                <div 
                                                                                                    key={index} 
                                                                                                    className="pointer step-inner" 
                                                                                                    onClick={() => this.changeReimburse(index, objIndex)}
                                                                                                >
                                                                                                    <div className={index === pet.reimburseId ? 'step-dot step-slected' : 'step-dot'}></div>
                                                                                                    <strong>{obj.reimbursment}%</strong>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={24} sm={2} md={2} lg={2} xl={2} className="text-center mt-4">
                                                                                <Divider type="vertical" className="border-vtcl-lg" />
                                                                            </Col>
                                                                            <Col xs={24} sm={11} md={11} lg={11} xl={11} className="text-center mt-4">
                                                                                <Title level={5} className="text-muted mb-4">DEDUCTIBLE</Title>
                                                                                <div className="steper">
                                                                                    {[{value: 100, key:500}, {value:250, key:1000}, {value:500, key:2000}].map((obj, index) => {
                                                                                        if(pet.looseRatioBreached){
                                                                                            if(index === 2){
                                                                                                return (
                                                                                                    <div 
                                                                                                        key={index} 
                                                                                                        className="pointer step-inner" 
                                                                                                        onClick={() => this.changeDeduction(index, objIndex)}
                                                                                                    >
                                                                                                        <div className={index === pet.deductionId ? 'step-dot step-slected' : 'step-dot'}></div>
                                                                                                        <strong>{CURRENCY || 'AED'} {obj.key}</strong>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            return null;
                                                                                        }
                                                                                        else{
                                                                                            return (
                                                                                                <div 
                                                                                                    key={index} 
                                                                                                    className="pointer step-inner" 
                                                                                                    onClick={() => this.changeDeduction(index, objIndex)}
                                                                                                >
                                                                                                    <div className={index === pet.deductionId ? 'step-dot step-slected' : 'step-dot'}></div>
                                                                                                    <strong>{CURRENCY || 'AED'} {obj.key}</strong>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>

                                                                        {/* Sidebar */}
                                                                        <Row gutter={15} justify="center">
                                                                            <Col xs={24} sm={24} md={24} lg={24} xl={8} className="mt-5 mb-5">
                                                                                <Sidebar />
                                                                            </Col>
                                                                        </Row>

                                                                        {/* Add Pet Button */}
                                                                        {this.state.preQoute.petsWithPlans.length < 5 && 
                                                                         this.state.preQoute.petsWithPlans.length === (objIndex + 1) && (
                                                                            <div className="add-pet">
                                                                                <Button type="link" className="text-light-green" onClick={this.showModal}>
                                                                                    <div className="icon"><i className="fa fa-plus-circle"></i></div>
                                                                                    Add A Pet 
                                                                                </Button>
                                                                                <span className="icon-info text-light-green font-600">
                                                                                    <Tooltip 
                                                                                        overlayClassName="tooltip-blue" 
                                                                                        color={'#57C6D6'} 
                                                                                        placement="left"
                                                                                        title={<div className="tooltip-content">Receive 5% discount when adding multiple pets.</div>}
                                                                                    >
                                                                                        <InfoCircleOutlined />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </Card>
                                                                </Fragment>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}
                                            
                                            {/* Action Buttons */}
                                            {dataLoaded && (
                                                <div className="steps-content mt-5">
                                                    <div>
                                                        <div className="steps-action full-width mt-5 text-center">
                                                            <Button 
                                                                size="large" 
                                                                className="mx-2 btn-red" 
                                                                onClick={this.continuePurchase}
                                                            >
                                                                Continue
                                                            </Button>
                                                        </div>
                                                        {
                                                            this.state.leadId &&
                                                            <div className="steps-action full-width mt-2 text-center">
                                                                <Button 
                                                                    type="text" 
                                                                    size="large" 
                                                                    className="mx-2 rounded-100" 
                                                                    onClick={this.saveQuote}
                                                                >
                                                                    Not ready? Save your quote
                                                                </Button>
                                                            </div>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Fragment>
                    
                </Spin>
                
                {/* Add/Edit Pet Modal */}
                <Modal
                    title={
                        <div className="text-dark-green font-600">
                            {this.state.isEditing ? 'Edit Pet' : 'Add a Pet'}
                        </div>
                    }
                    visible={this.state.visible}
                    footer={null}
                    closable={true}
                    onCancel={this.handleCancel}
                >
                    <Form
                        key={this.state.isEditing ? `edit-${this.state.editingPetIndex}` : 'add'}
                        name="basic"
                        onFinish={this.addPetForm}
                        onFinishFailed={this.onPetFormFailed}
                        size="large"
                        className="customise-form"
                        ref={this.formRef}
                    >
                        
                        <Form.Item
                            name="name"
                            rules={[{ required: true, message: 'Please input name!' }]}
                        >
                            <Input placeholder="Pet's Name *" />
                        </Form.Item>

                        <Row gutter={15} justify="center">
                            <Col sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    className="text-center"
                                    name="type"
                                    rules={[{ required: true, message: 'Please select pet type!' }]}
                                >
                                    <Spin spinning={this.state.spin}>
                                        {this.state.petTypeBreeds.length > 0 && (
                                            <Radio.Group 
                                                buttonStyle="solid" 
                                                onChange={this.changeType}
                                            >
                                                {this.state.petTypeBreeds.map((type) => (
                                                    <Radio.Button key={type.id} value={type.id}>
                                                        {type.name}
                                                    </Radio.Button>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Spin>
                                </Form.Item>
                            </Col>
                            <Col sm={12} md={12} lg={12} xl={12}>
                                <Form.Item 
                                    className="text-center" 
                                    name="gender"
                                    rules={[{ validator: this.validateGender }]}
                                    validateTrigger={['onChange', 'onBlur']}
                                >
                                    <Radio.Group 
                                        buttonStyle="solid"
                                        onChange={(e) => {
                                            // Clear validation errors when user makes a selection
                                            if (this.formRef.current) {
                                                this.formRef.current.setFields([
                                                    { name: 'gender', errors: [] }
                                                ]);
                                            }
                                        }}
                                    >
                                        <Radio.Button value="Male">Male</Radio.Button>
                                        <Radio.Button value="Female">Female</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Form.Item
                            name="age"
                            validateTrigger={['onBlur']}
                            rules={[
                                { validator: this.validatePetAge }
                            ]}
                        >
                                <DatePicker 
                                    onChange={this.ageChange} 
                                    style={{ width: '100%' }} 
                                    placeholder={!this.state.selectedPetType 
                                        ? "Please select pet type first" 
                                        : "Please select DOB (MM/YYYY)!"
                                    } 
                                    format="MM/YYYY" 
                                    picker="month"
                                    disabled={!this.state.selectedPetType}
                                    disabledDate={(current) => {
                                        // Disable future dates
                                        if (current && current > moment().endOf('month')) {
                                            return true;
                                        }
                                        
                                        // If pet type is selected, apply age restrictions
                                        if (this.state.selectedPetType && current) {
                                            const selectedType = this.state.petTypeBreeds.find(type => type.id === this.state.selectedPetType);
                                            const petTypeName = selectedType?.name?.toLowerCase();
                                            const ageInYears = moment().diff(current, 'years', true);
                                            
                                            // Disable dates that would make pet too old
                                            if (petTypeName === 'dog' && ageInYears > 8) {
                                                return true;
                                            }
                                            if (petTypeName === 'cat' && ageInYears > 10) {
                                                return true;
                                            }
                                        }
                                        
                                        return false;
                                    }}
                                />
                        </Form.Item>

                        <Form.Item
                            name="breed"
                            rules={[{ required: true, message: 'Please select breed!' }]}
                        >
                            <Select 
                                placeholder="Select Breed"
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                            >
                                {filteredBreeds && filteredBreeds.map((breed, index) => (
                                    <Option key={index} value={breed.id}>{breed.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item className="mb-0 text-center">
                                <Button 
                                    className="text-muted btn-150" 
                                    type="link" 
                                    onClick={this.handleCancel} 
                                    size="large"
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    disabled={this.state.disableBtn} 
                                    type="primary" 
                                    htmlType="submit" 
                                    size="large" 
                                    className="btn-outline-light-green btn-150 rounded-100"
                                >
                                    {this.state.isEditing ? 'Update' : 'Add Pet'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Form>
                </Modal>
                </MainLayout>
            </Fragment>
        );
    }
}

export default GetQouteFlowSecond;